// dummy row click handler to disable fullRow selection click
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};
